<template>
  <div>
    <b-modal id="modalEditSystemGroups" ref="modalEditSystemGroups" :title="$t('System group')" hide-footer @shown="shown" size="xl">
      <div v-if="editItem">
        <b-tabs vertical pills card>

          <b-tab :title="$t('Main')" active>
            <b-form-group label-align="right" label="ID" label-cols="4" label-cols-xl="4" label-cols-md="4" v-if="editItem.group_id">
              <b-form-input type="text" v-model="editItem.group_id" disabled/>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('Full name')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-input :disabled="editItem.group_id == 1" type="text" v-model="editItem.group_name" aria-describedby="inputFeedbackName" :state="editItem.group_name.length > 0"/>
              <b-form-invalid-feedback id="inputFeedbackName">
                {{ $t('Enter title') }}
              </b-form-invalid-feedback>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('Comments')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-input :disabled="editItem.group_id == 1" type="text" v-model="editItem.group_info"/>
            </b-form-group>
          </b-tab>

          <b-tab title="URFA" v-if="editItem.group_id && editItem.group_id != 1">
            <b-tabs>

              <b-tab title="Urfa All">
                <b-form-group label-align="right" :label="$t('Filter')" label-cols="4" label-cols-xl="4" label-cols-md="4" >
                  <b-input-group>
                    <b-form-input v-model="filter" :placeholder="$t('Type to Search')" @update="filterChanged"/>
                  </b-input-group>
                </b-form-group>
                <b-table striped hover small responsive class="my-table"
                :items="func"
                :fields="funcFields"
                :filter="filter">
                  <template v-slot:cell(is_allowed)="row">
                    <b-form-checkbox v-model="row.item.is_allowed"/>
                  </template>
                </b-table>
              </b-tab>
              <b-tab title="Urfa Tree">
                <urfaTree :enabledFids="func" @allowanceFid="allowanceFid"/>
              </b-tab>
            </b-tabs>
          </b-tab>
          <b-tab :title="$t('Web tabs')" v-if="editItem.group_id && editItem.group_id != 1">
            <b-form-checkbox switch v-model.number="autoEnableRestAPI">{{ $t('Auto enable/disable RestAPI')}}</b-form-checkbox>
            <md-button class="md-raised" @click="changeEnableAllWebTabs(true)" >{{ $t('Enable all') }}</md-button>
            <md-button class="md-raised md-accent" @click="changeEnableAllWebTabs(false)" >{{ $t('Disable all') }}</md-button>
            <md-button class="md-raised md-primary" @click="applyToRestAPI" >{{ $t('Apply to RestAPI') }}</md-button>

            <b-table striped hover small responsive class="my-table"
            :items="webTabItems"
            :fields="webTabsFields"
            selectable
            @row-selected="onRowSelected">
              <template v-slot:cell(name)="data">
                {{ $t(data.value) }}
              </template>
              <template v-slot:cell(is_allowed)="row">
                <b-form-checkbox v-model="row.item.is_allowed"/>
              </template>
              <template slot="row-details" slot-scope="row">
                <b-card style="margin:1px">
                  <b-table striped hover small responsive
                  :items="row.item.items"
                  :fields="webTabsDetailFields">
                    <template v-slot:cell(name)="data">
                      {{ $t(data.value) }}
                    </template>
                    <template v-slot:cell(is_allowed)="row">
                      <b-form-checkbox switch size="lg" v-model="row.item.is_allowed" @change="applyToRestAPI"/>
                    </template>
                  </b-table>
                </b-card>
              </template>
            </b-table>

            <b-form-group label-align="right" :label="$t('Enabled tabs')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-input :disabled="true" type="text" v-model="countEnabledTabs"/>
            </b-form-group>
          </b-tab>

          <b-tab :title="$t('RestAPI')" v-if="editItem.group_id && editItem.group_id != 1">
            <b-row>
              <b-col>
                <nodeTree v-if="allRoutesPrepared" @endpointClicked="restApiRouteClicked" :node="allRoutesPrepared"/>
              </b-col>
              <b-col>
                <div v-if="currentNode">
                  {{ currentNode.full_path }}
                  <div v-if="currentNode.methods">
                    <b-form-group v-if="currentNode.methods.get !== undefined" label-align="right" label="Get" label-cols="4" label-cols-xl="4" label-cols-md="4">
                      <b-form-checkbox switch size="lg" v-model="currentNode.methods.get"/>
                    </b-form-group>
                    <b-form-group v-if="currentNode.methods.put !== undefined" label-align="right" label="Put" label-cols="4" label-cols-xl="4" label-cols-md="4">
                      <b-form-checkbox switch size="lg" v-model="currentNode.methods.put"/>
                    </b-form-group>
                    <b-form-group v-if="currentNode.methods.post !== undefined" label-align="right" label="Post" label-cols="4" label-cols-xl="4" label-cols-md="4">
                      <b-form-checkbox switch size="lg" v-model="currentNode.methods.post"/>
                    </b-form-group>
                    <b-form-group v-if="currentNode.methods.delete !== undefined" label-align="right" label="Delete" label-cols="4" label-cols-xl="4" label-cols-md="4">
                      <b-form-checkbox switch size="lg" v-model="currentNode.methods.delete"/>
                    </b-form-group>
                  </div>
                </div>
              </b-col>
            </b-row>
          </b-tab>
        </b-tabs>

        <modal-ok-cancel v-if="editItem.group_id != 1" @save="save" @cancel="$bvModal.hide('modalEditSystemGroups')" size="xl"/>
      </div>
    </b-modal>
  </div>
</template>

<style>
.my-table {
  max-height: 400px;
  overflow-y: auto;
}
</style>

<script>
import nodeTree from '@/components/NodeTree.vue'
import urfaTree from './urfasTree.vue'

export default {
  components: {
    nodeTree,
    urfaTree
  },
  props: {
    editItem: null
  },
  data () {
    return {
      autoEnableRestAPI: true,
      currentNode: null,
      webTabItems: [],
      webTabsDetailFields: [
        {key: 'name', label: this.$i18n.t('Name'), sortable: true},
        {key: 'is_allowed', label: this.$i18n.t('Is allowed'), sortable: true}
      ],
      webTabsFields: [
        {key: 'name', label: this.$i18n.t('Name'), sortable: true},
        {key: 'allowed_count',
          label: this.$i18n.t('Allowed count'),
          sortable: true,
          formatter: (value, key, item) => {
            let count = 0
            for (let el of item.items) {
              if (el.is_allowed) {
                count++
              }
            }
            return count
          }}
      ],
      funcFields: [
        {key: 'number', label: this.$i18n.t('Function ID'), sortable: true},
        {key: 'fid_name', label: this.$i18n.t('Function name'), sortable: true},
        {key: 'fid_module', label: this.$i18n.t('Module'), sortable: true},
        {key: 'is_allowed', label: this.$i18n.t('Is allowed'), sortable: true}
      ],
      allRoutesPrepared: null,
      filter: '',
      selected: null,
      searchDocumentImage: require('@/assets/img/search.png')
    }
  },
  methods: {
    allowanceFid (index, val) {
      this.func[index].is_allowed = val
    },
    async applyToRestAPI () {
      let done = await this.recursiveNodeChangeAll(false, this.allRoutesPrepared)
      if (done) {

      }

      for (let el of this.webTabItems) {
        for (let tab of el.items) {
          if (tab.is_allowed) {
            this.changeAllowedTab(tab, tab.is_allowed)
          }
        }
      }
    },
    changeAllowedTab (tab, isAllowed) {
      if (this.autoEnableRestAPI && tab.rest_api) {
        if (tab.rest_api.get) {
          for (let el of tab.rest_api.get) {
            this.recursiveNodeSetAllowed(isAllowed, el, 'get', this.allRoutesPrepared)
          }
        }
        if (tab.rest_api.put) {
          for (let el of tab.rest_api.put) {
            this.recursiveNodeSetAllowed(isAllowed, el, 'put', this.allRoutesPrepared)
          }
        }
        if (tab.rest_api.post) {
          for (let el of tab.rest_api.post) {
            this.recursiveNodeSetAllowed(isAllowed, el, 'post', this.allRoutesPrepared)
          }
        }
        if (tab.rest_api.delete) {
          for (let el of tab.rest_api.delete) {
            this.recursiveNodeSetAllowed(isAllowed, el, 'delete', this.allRoutesPrepared)
          }
        }
      }
    },
    onRowSelected (items) {
      for (let i in this.selected) {
        for (let j in items) {
          if (this.selected[i] === items[j]) {
            break
          }
        }
        this.selected[i]._showDetails = false
      }
      this.selected = items
      for (let i in this.selected) {
        this.selected[i]._showDetails = true
      }
    },
    async save () {
      if (!this.editItem.group_name) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Name field is invalid'), 'Error')
        return
      }

      this.editItem.fids = []
      for (let el of this.func) {
        if (el.is_allowed) {
          let newEl = {
            fid: 0,
            allowed: 1
          }
          newEl.fid = el.fid_id
          this.editItem.fids.push(newEl)
        }
      }
      for (let el of this.webTabItems) {
        delete el['_showDetails']
        for (let elItem of el.items) {
          delete elItem['rest_api']
        }
      }
      let tmp = btoa(unescape(encodeURIComponent(JSON.stringify(this.webTabItems))))
      this.editItem.web_settings = tmp
      let response = this.editItem.group_id !== 0
        ? this.$store.dispatch('Users/UPDATE_SYSTEM_GROUPS', this.editItem)
        : this.$store.dispatch('Users/CREATE_SYSTEM_GROUPS', this.editItem)
      response.then(async response => {
        if (response.data.error) {
          this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
        } else {
          setTimeout(this.$store.dispatch, 500, 'Users/GET_SYSTEM_GROUPS')

          if (this.editItem.group_id !== 0) {
            let allowedAPI = []
            let done = await this.recursiveNodeFind(allowedAPI, this.editItem.group_id, this.allRoutesPrepared)
            if (done) {
              let tmpData = {
                groupID: this.editItem.group_id,
                data: allowedAPI
              }
              let response = this.$store.dispatch('Settings/CREATE_API_PERMISSIONS', tmpData)
              response.then(async response => {
                setTimeout(this.$store.dispatch, 500, 'Settings/GET_API_PERMISSIONS')
              })
            }
          }
          this.$refs.modalEditSystemGroups.hide()
          this.$root.$emit('makeToasts')
        }
      })
    },
    async recursiveNodeChangeAll (isAllowed, node) {
      if (node.nodes) {
        for (let el of node.nodes) {
          let done = await this.recursiveNodeChangeAll(isAllowed, el)
          if (done) {

          }
        }
      }
      if (node.methods) {
        for (let key in node.methods) {
          node.methods[key] = isAllowed
        }
      }
      return true
    },
    async recursiveNodeSetAllowed (isAllowed, fullPath, method, node) {
      if (node.nodes) {
        for (let el of node.nodes) {
          let done = await this.recursiveNodeSetAllowed(isAllowed, fullPath, method, el)
          if (done) {
            return true
          }
        }
      }
      if (node.full_path !== fullPath) {
        return false
      }
      if (node.methods) {
        for (let key in node.methods) {
          if (key === method) {
            node.methods[key] = isAllowed
            return true
          }
        }
      }
      return true
    },
    async recursiveNodeFind (allowedAPI, groupID, node) {
      if (node.nodes) {
        for (let el of node.nodes) {
          let done = await this.recursiveNodeFind(allowedAPI, groupID, el)
          if (done) {
            continue
          }
        }
      }
      if (node.methods) {
        for (let key in node.methods) {
          if (node.methods[key]) {
            let newAllowedAPI = {
              url: node.full_path,
              method: this.strMethodToInt(key),
              system_group_id: groupID
            }
            allowedAPI.push(newAllowedAPI)
          }
        }
      }
      return true
    },
    strMethodToInt (method) {
      switch (method) {
        case 'all':
          return -1
        case 'get':
          return 0
        case 'post':
          return 1
        case 'put':
          return 2
        case 'delete':
          return 3
      }
    },
    shown () {
      if (this.editItem.group_id !== 0) {
        this.$store.dispatch('Users/GET_INFO_GROUP', this.editItem.group_id)
      }
      this.currentNode = null
    },
    filterChanged (value) {
      this.filter = value
    },
    restApiRouteClicked (node) {
      this.currentNode = node
    },
    changeEnableAllWebTabs (isAllowed) {
      for (let el of this.webTabItems) {
        for (let tab of el.items) {
          tab.is_allowed = isAllowed

          if (tab.rest_api && this.autoEnableRestAPI) {
            if (tab.rest_api.get) {
              for (let el of tab.rest_api.get) {
                this.recursiveNodeSetAllowed(isAllowed, el, 'get', this.allRoutesPrepared)
              }
            }
            if (tab.rest_api.put) {
              for (let el of tab.rest_api.put) {
                this.recursiveNodeSetAllowed(isAllowed, el, 'put', this.allRoutesPrepared)
              }
            }
            if (tab.rest_api.post) {
              for (let el of tab.rest_api.post) {
                this.recursiveNodeSetAllowed(isAllowed, el, 'post', this.allRoutesPrepared)
              }
            }
            if (tab.rest_api.delete) {
              for (let el of tab.rest_api.delete) {
                this.recursiveNodeSetAllowed(isAllowed, el, 'delete', this.allRoutesPrepared)
              }
            }
          }
        }
      }
    }
  },
  watch: {
    editItem: function (val) {
      let initValues = JSON.parse(JSON.stringify(this.initWebTabItems))
      let tmp = JSON.parse(atob(val.web_settings))
      if (Array.isArray(tmp)) {
        for (let elGroup of tmp) {
          for (let elInitGroup of initValues) {
            if (elGroup.name === elInitGroup.name) {
              for (let elGroupData of elGroup.items) {
                for (let elInitGroupData of elInitGroup.items) {
                  if (elGroupData.name === elInitGroupData.name) {
                    elInitGroupData.is_allowed = elGroupData.is_allowed
                  }
                }
              }
            }
          }
        }
      }
      this.webTabItems = initValues
    },
    allRoutes: function (val) {
      let tmp = []
      for (let elMethod of val) {
        for (let elURL of elMethod.url) {
          let splittedURL = elURL.split('/')
          let currentNode = tmp
          for (let elSplURL of splittedURL) {
            if (!elSplURL.length || elSplURL === 'api') {
              continue
            }
            let isFound = false

            for (let elNodes of currentNode) {
              if (elNodes.path === elSplURL) {
                if (elSplURL === splittedURL[splittedURL.length - 1]) {
                  currentNode = elNodes
                } else {
                  currentNode = elNodes.nodes
                }
                isFound = true
              }
            }

            if (!isFound) {
              let newNode = {
                path: elSplURL,
                nodes: []
              }

              currentNode.push(newNode)
              if (elSplURL === splittedURL[splittedURL.length - 1]) {
                currentNode = newNode
              } else {
                currentNode = newNode.nodes
              }
            }
          }
          if (!currentNode.methods) {
            let isAllowedURL = false
            if (this.editItem.group_id !== 0) {
              for (let elAP of this.apiPermissions) {
                if (elAP.system_group_id === this.editItem.group_id && elAP.url === elURL && elMethod.method === elAP.method) {
                  isAllowedURL = true
                }
              }
            }
            currentNode.endpoint = true
            this.$set(currentNode, 'methods', {})
            switch (elMethod.method) {
              case 0:
                currentNode.methods = {
                  get: isAllowedURL
                }
                break
              case 1:
                currentNode.methods = {
                  post: isAllowedURL
                }
                break
              case 2:
                currentNode.methods = {
                  put: isAllowedURL
                }
                break
              case 3:
                currentNode.methods = {
                  delete: isAllowedURL
                }
                break
            }
            currentNode.full_path = elURL
          } else {
            let isAllowedURL = false
            if (this.editItem.group_id !== 0) {
              for (let elAP of this.apiPermissions) {
                if (elAP.system_group_id === this.editItem.group_id && elAP.url === elURL && elMethod.method === elAP.method) {
                  isAllowedURL = true
                  break
                }
              }
            }
            switch (elMethod.method) {
              case 0:
                currentNode.methods.get = isAllowedURL
                break
              case 1:
                currentNode.methods.post = isAllowedURL
                break
              case 2:
                currentNode.methods.put = isAllowedURL
                break
              case 3:
                currentNode.methods.delete = isAllowedURL
                break
            }
          }
        }
      }
      let tmpp = {
        path: '/api',
        nodes: tmp
      }
      this.allRoutesPrepared = tmpp
    }
  },
  computed: {
    countEnabledTabs () {
      let all = 0
      let enabled = 0
      for (let el of this.webTabItems) {
        for (let tab of el.items) {
          all++
          enabled += tab.is_allowed ? 1 : 0
        }
      }
      return enabled + '/' + all
    },
    func () {
      let copy = this.$store.getters['Users/INFO_GROUP'].fids
      for (let el of copy) {
        el.number = '0x' + JSON.parse(JSON.stringify(el.fid_id.toString(16)))
      }
      return copy
    },
    allRoutes () {
      if (this.editItem) {
        return this.$store.getters['Settings/ALL_ROUTES']
      } else {
        return []
      }
    },
    apiPermissions () {
      return this.$store.getters['Settings/API_PERMISSIONS']
    },
    initWebTabItems () {
      return this.$store.getters['Users/INIT_WEB_TAB_ITEMS']
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/users/systemGroups/editModal.vue